import React, { useRef } from 'react';
import { classIf } from '../data/utils';
import { isOddUnderMinValue, useOddData } from './OddWrapper';
import { useHighlightOddChange } from './useHighlightOddChange';

export default function FastBetsOdd(props) {
    const oddContainer = useRef(null);
    
    useHighlightOddChange(oddContainer, props.value, props.matchData.isLive);
    const [desc, selected, addBet] = useOddData(props);
    
    return (
        <>
            {props.value == null || isOddUnderMinValue(props.rawValue) ?
                <li>
                    <div ref={oddContainer} className={"fast-bets-odd pointer" + classIf(selected, 'selezionata')} onClick={addBet}>{desc} : <i className="fa fa-lock"></i></div>
                </li>
                :
                <li>
                    <div ref={oddContainer} className={"fast-bets-odd pointer" + classIf(selected, 'selezionata')} onClick={addBet} >{desc} : {props.value}</div>
                </li>
            }
        </>
    );
}
